import { render } from "./RelatorioBuscaPlaca.vue?vue&type=template&id=c5b76070&scoped=true&ts=true"
import script from "./RelatorioBuscaPlaca.vue?vue&type=script&lang=ts"
export * from "./RelatorioBuscaPlaca.vue?vue&type=script&lang=ts"

import "./RelatorioBuscaPlaca.vue?vue&type=style&index=0&id=c5b76070&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5b76070"]])

export default __exports__